<template>
  <van-tabbar v-model="active" active-color="#00b5ff" fixed route>
    <van-tabbar-item :to="item.to" v-for="(item, i) in tabs" :key="i">
      <span>{{ item.name }}</span>
      <template #icon="props">
        <img :src="props.active ? item.active : item.inactive" />
      </template>
    </van-tabbar-item>
    <!--  <van-tabbar-item  icon="shop-o"  to="/bmfw" >便民服务</van-tabbar-item>
	  <van-tabbar-item  icon="friends-o" to="/user">个人中心</van-tabbar-item> -->
  </van-tabbar>
</template>
  <script type="text/javascript">
    import Vue from 'vue';
    import { Tabbar, TabbarItem } from 'vant';

    Vue.use(Tabbar);
    Vue.use(TabbarItem);
  export default {
    data() {
      return {
        active: 0,
		tabs: [{
			name:'首页',
			to:'/home',
			inactive: require('../../assets/icon/sy.png'),
			active:  require('../../assets/icon/syon.png'),
		 },
		 {
			name:'企业端',
			to:'/wuye',
			inactive: require('../../assets/newicon/qy.png'),
			active:  require('../../assets/newicon/qyon.png'),
		 },
		 {
			name:'个人中心',
			to:'/user',
			inactive: require('../../assets/icon/grzx.png'),
			active:  require('../../assets/icon/grzxon.png'),
		 }],
      }
    },
    methods: {
     
    },
		mounted() {//0223新需求 如果是游客 就要实名
			if(sessionStorage.getItem('isYouke')){
												this.tabs=[{
			name:'首页',
			to:'/home',
			inactive: require('../../assets/icon/sy.png'),
			active:  require('../../assets/icon/syon.png'),
		 },
		 		 {
			name:'企业端',
			to:'/wuye',
			inactive: require('../../assets/newicon/qy.png'),
			active:  require('../../assets/newicon/qyon.png'),
		 },
		 {
			name:'个人中心',
			to:'/smrz',
			inactive: require('../../assets/icon/grzx.png'),
			active:  require('../../assets/icon/grzxon.png'),
		 }]
			}
		},
  }
  </script>
  <style type="text/css" scoped="scoped">
</style>
